<template>
  <article :id="`expanded-${course.id}`" class="expanded">
    <div class="expanded__content-left">
      <h5 class="expanded__course-title content-title">
        {{ course.title }}
      </h5>
      <div v-if="presenter" class="expanded__instructor-wrapper">
        <div
          @click="$emit('search-presenter', presenter.name)"
          class="expanded__instructor-img-wrapper"
        >
          <img
            class="expanded__instructor-img"
            :src="$getInstructorImg(presenter.profile_img_url)"
            :alt="`INE Instructor ${presenter.name}`"
          />
        </div>
        <div class="expanded__instructor-details-wrapper">
          <p class="lead">Instructor</p>
          <p class="data">{{ presenter.name }}</p>
          <template v-if="certifications.length">
            <p class="lead">
              Certifications
            </p>
            <p class="data">
              {{ certifications }}
            </p>
          </template>
        </div>
      </div>
    </div>
    <div class="expanded__content-right">
      <div class="expanded__content-top">
        <p class="expanded__course-description content-description">
          {{ course.description | truncateText }}
        </p>
        <div class="expanded__close-btn-wrapper">
          <button class="expanded__close-btn" @click="$emit('close')">
            <i class="material-icons">close</i>
          </button>
        </div>
      </div>
      <div class="expanded__content-bottom">
        <p class="expanded__duration">
          <span class="lead">Course Duration:</span>
          <span class="data">{{ duration }}</span>
        </p>
        <div class="expanded__difficulty">
          <span class="lead">Difficulty Level:</span>
          <Difficulty :difficulty="course.difficulty" class="data" />
        </div>
        <div class="expanded__buttons-wrapper">
          <Active :course="{ id: course.objectID }" />
          <router-link
            :to="$buildContentLink('course', course)"
            class="btn btn--primary expanded__view-btn"
          >
            View Course
          </router-link>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import Difficulty from '@/components/properties/Difficulty.vue'
import Active from '@/components/properties/Active.vue'

export default {
  name: 'CourseCarouselExpanded',
  components: {
    Difficulty,
    Active,
  },
  props: {
    course: {
      type: Object,
      required: true,
    },
    presenter: {
      type: Object,
      required: true,
    },
    duration: {
      type: String,
      required: true,
    },
  },
  computed: {
    certifications() {
      const { certifications } = this.presenter
      return [certifications.map(cert => cert.name)].join(', ')
    },
  },
  filters: {
    truncateText(value) {
      if (value.length > 500) {
        return `${value.substr(0, 500)}...`
      }
      return value
    },
  },
  mounted() {
    this.$scrollTo(`[id='expanded-${this.course.id}']`, 1000, {
      container: 'body',
      offset: -200,
    })
  },
}
</script>

<style lang="scss" scoped>
.expanded {
  margin-top: 15px;
  background-color: var(--light-gray);
  min-height: 400px;
  width: 100%;
  border-radius: 5px;
  padding: 50px;
  display: flex;
  flex-direction: column;
  @include tablet {
    flex-direction: row;
  }
  p {
    margin: 5px 0 0 0;
  }
  &__content-left {
    padding: 10px;
    @include tablet {
      width: 30%;
      padding: 20px 20px 20px 0;
      border-right: 1px solid var(--gray);
    }
  }
  &__course-title {
    line-height: 3rem;
    font-size: 2rem;
  }
  &__instructor-wrapper {
    display: flex;
  }
  &__instructor-img {
    width: 110px;
    border-radius: 100%;
    margin: 0 20px 0 0;
    transition: 0.5s all ease;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
  &__instructor-details-wrapper {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  &__content-right {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 30px 10px 10px 10px;
    @include tablet {
      width: 70%;
      padding: 20px 0 20px 40px;
    }
  }
  &__content-bottom {
    padding: 5px 0 0 0;
  }
  &__difficulty {
    display: flex;
    align-items: center;
    width: 100%;
    white-space: nowrap;
    margin: 5px 0 0 0;
  }
  .difficulty {
    width: auto;
  }
  &__buttons-wrapper {
    display: flex;
    justify-content: space-between;
    margin: 50px 0 0 0;
  }
  &__view-btn {
    margin-left: auto;
  }
  &__close-btn {
    position: absolute;
    top: -50px;
    right: 0;
    background-color: transparent;
    color: var(--white);
    border: none;
    transition: 0.5s all ease-out;
    font-size: 1.7rem;
    z-index: 2;
    &:hover {
      background-color: transparent;
      color: var(--orangae);
      cursor: pointer;
    }
  }
}
</style>
